import type React from 'react'
import type { ReactNode } from 'react'

import { ButtonStyled, CircularProgressStyled, WrapIconStyled } from './styles'

export enum DSButtonType {
  PRIMARY_BUTTON = 'hav-primary-button',
  BIG_PRIMARY_BUTTON = 'hav-big-primary-button',
  SM_PRIMARY_BUTTON = 'hav-sm-primary-button',
  GHOST_BUTTON = 'hav-ghost-button',
  ICON_BUTTON = 'hav-icon-button',
  BIG_ICON_BUTTON = 'hav-big-icon-button',
  SM_ICON_BUTTON = 'hav-sm-icon-button',
  TEXT_BUTTON = 'hav-text-button',
  ICON_PRIMARY_BUTTON = 'hav-icon-primary-button',
}

export interface ButtonProps {
  id?: string
  content?: string | ReactNode
  loading?: boolean
  disabled?: boolean
  active?: boolean
  type?: 'button' | 'submit' | 'reset'
  design?: DSButtonType
  color?: 'primary' | 'secondary'
  fullWidth?: boolean
  width?: string | number
  minwidth?: number
  height?: number
  margin?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  icon?: ReactNode
}

export const Button: React.FC<ButtonProps> = ({
  id = undefined,
  content = undefined,
  loading = false,
  disabled,
  active = false,
  type = 'button',
  color = 'primary',
  fullWidth = true,
  width,
  minwidth,
  height,
  margin = undefined,
  onClick,
  design = DSButtonType.PRIMARY_BUTTON,
  icon,
}) => {
  const hasIcon = [
    'hav-icon-button',
    'hav-icon-primary-button',
    'hav-big-icon-button',
    'hav-sm-icon-button',
  ].includes(design)

  return (
    <ButtonStyled
      active={active}
      color={color}
      data-testid="btn-component"
      design={design}
      disabled={loading || disabled}
      fullWidth={fullWidth}
      height={height}
      id={id}
      margin={margin}
      minwidth={minwidth}
      onClick={onClick}
      type={type}
      variant="contained"
      width={width}
    >
      {loading ? (
        <CircularProgressStyled data-testid="svg-load" />
      ) : (
        <>
          {hasIcon && (
            <WrapIconStyled color={color} data-testid="wrap-icon-button" iconContent={content}>
              {icon}
            </WrapIconStyled>
          )}
          {content}
        </>
      )}
    </ButtonStyled>
  )
}
